import state from "./state";
import "./styles.scss";
document.addEventListener("DOMContentLoaded", () => {
    const proList = document.getElementById("pro-list");
    const conList = document.getElementById("con-list");
    const proEmpty = document.getElementById("pro-empty");
    const conEmpty = document.getElementById("con-empty");
    const proCount = document.getElementById("pro-count");
    const conCount = document.getElementById("con-count");
    const scaleValue = document.getElementById("decision-scale");
    const verdictLabel = document.getElementById("verdict-label");
    const balanceFillPro = document.getElementById("balance-fill-pro");
    const balanceFillCon = document.getElementById("balance-fill-con");
    const clearButton = document.getElementById("clear-button");
    const modal = document.getElementById("modal");
    const openModalButton = document.getElementById("open-modal");
    const closeModalButton = document.getElementById("close-modal");
    const cancelModalButton = document.getElementById("cancel-modal");
    const modalBackdrop = document.getElementById("modal-backdrop");
    const addForm = document.getElementById("add-form");
    const nameInput = document.getElementById("item");
    const weightInput = document.getElementById("weight");
    const weightValue = document.getElementById("weight-value");
    const confirmModal = document.getElementById("confirm-modal");
    const confirmBackdrop = document.getElementById("confirm-backdrop");
    const confirmCloseButton = document.getElementById("confirm-close");
    const confirmCancelButton = document.getElementById("confirm-cancel");
    const confirmClearButton = document.getElementById("confirm-clear");
    const createDialogController = (dialog, initialFocus) => {
        let lastFocusedElement = null;
        const getFocusableElements = () => {
            if (!dialog) {
                return [];
            }
            return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
        };
        const close = () => {
            if (!dialog) {
                return;
            }
            dialog.hidden = true;
            document.removeEventListener("keydown", handleKeydown);
            lastFocusedElement === null || lastFocusedElement === void 0 ? void 0 : lastFocusedElement.focus();
        };
        const handleKeydown = (event) => {
            if (event.key === "Escape") {
                close();
                return;
            }
            if (event.key !== "Tab") {
                return;
            }
            const focusable = getFocusableElements();
            if (focusable.length === 0) {
                return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        };
        const open = () => {
            if (!dialog) {
                return;
            }
            lastFocusedElement = document.activeElement;
            dialog.hidden = false;
            initialFocus === null || initialFocus === void 0 ? void 0 : initialFocus.focus();
            document.addEventListener("keydown", handleKeydown);
        };
        return { open, close };
    };
    const addDialog = createDialogController(modal, nameInput);
    const confirmDialog = createDialogController(confirmModal, confirmCancelButton);
    const updateWeightDisplay = () => {
        if (!weightInput) {
            return;
        }
        const min = Number(weightInput.min) || 1;
        const max = Number(weightInput.max) || 10;
        const value = Number(weightInput.value);
        const percent = ((value - min) / (max - min)) * 100;
        weightInput.style.setProperty("--range-fill", `${percent}%`);
        if (weightValue) {
            weightValue.textContent = String(value);
        }
    };
    const buildItemRow = (name, weight, type, id) => {
        const li = document.createElement("li");
        li.className = "item-row";
        li.dataset.id = String(id);
        const nameSpan = document.createElement("span");
        nameSpan.className = "item-name";
        nameSpan.textContent = name;
        const actions = document.createElement("div");
        actions.className = "item-actions";
        const weightChip = document.createElement("span");
        weightChip.className = `weight-chip weight-chip--${type}`;
        weightChip.textContent = type === "pro" ? `+${weight}` : `-${weight}`;
        const deleteButton = document.createElement("button");
        deleteButton.className = "item-delete";
        deleteButton.type = "button";
        deleteButton.setAttribute("aria-label", `Remove "${name}"`);
        deleteButton.innerHTML =
            '<svg class="icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1l1-13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        deleteButton.addEventListener("click", () => {
            state.removeItem(id);
            render();
        });
        actions.appendChild(weightChip);
        actions.appendChild(deleteButton);
        li.appendChild(nameSpan);
        li.appendChild(actions);
        return li;
    };
    const render = () => {
        const items = state.getItems();
        const proItems = items.filter((item) => item.type === "pro");
        const conItems = items.filter((item) => item.type === "con");
        if (proList) {
            proList.innerHTML = "";
            proItems.forEach((item) => proList.appendChild(buildItemRow(item.name, item.weight, item.type, item.id)));
        }
        if (conList) {
            conList.innerHTML = "";
            conItems.forEach((item) => conList.appendChild(buildItemRow(item.name, item.weight, item.type, item.id)));
        }
        proEmpty === null || proEmpty === void 0 ? void 0 : proEmpty.classList.toggle("is-visible", proItems.length === 0);
        conEmpty === null || conEmpty === void 0 ? void 0 : conEmpty.classList.toggle("is-visible", conItems.length === 0);
        if (proCount) {
            proCount.textContent = String(proItems.length);
        }
        if (conCount) {
            conCount.textContent = String(conItems.length);
        }
        const totalPro = proItems.reduce((acc, item) => acc + item.weight, 0);
        const totalCon = conItems.reduce((acc, item) => acc + item.weight, 0);
        const total = totalPro - totalCon;
        const combined = totalPro + totalCon;
        if (scaleValue) {
            scaleValue.textContent = (total > 0 ? "+" : "") + total.toString();
        }
        if (verdictLabel) {
            if (items.length === 0) {
                verdictLabel.textContent = "Add items to see your verdict";
            }
            else if (total > 0) {
                verdictLabel.textContent = "Leaning toward yes";
            }
            else if (total < 0) {
                verdictLabel.textContent = "Leaning toward no";
            }
            else {
                verdictLabel.textContent = "Too close to call";
            }
        }
        const proPercent = combined === 0 ? 50 : (totalPro / combined) * 100;
        const conPercent = combined === 0 ? 50 : (totalCon / combined) * 100;
        if (balanceFillPro) {
            balanceFillPro.style.width = `${proPercent}%`;
        }
        if (balanceFillCon) {
            balanceFillCon.style.width = `${conPercent}%`;
        }
        if (clearButton) {
            clearButton.disabled = items.length === 0;
        }
    };
    const openModal = () => {
        addDialog.open();
        updateWeightDisplay();
    };
    const closeModal = () => {
        addDialog.close();
        addForm === null || addForm === void 0 ? void 0 : addForm.reset();
        updateWeightDisplay();
    };
    const addListeners = () => {
        clearButton === null || clearButton === void 0 ? void 0 : clearButton.addEventListener("click", () => {
            if (state.getItems().length === 0) {
                return;
            }
            confirmDialog.open();
        });
        confirmCancelButton === null || confirmCancelButton === void 0 ? void 0 : confirmCancelButton.addEventListener("click", () => confirmDialog.close());
        confirmCloseButton === null || confirmCloseButton === void 0 ? void 0 : confirmCloseButton.addEventListener("click", () => confirmDialog.close());
        confirmBackdrop === null || confirmBackdrop === void 0 ? void 0 : confirmBackdrop.addEventListener("click", () => confirmDialog.close());
        confirmClearButton === null || confirmClearButton === void 0 ? void 0 : confirmClearButton.addEventListener("click", () => {
            state.clearItems();
            confirmDialog.close();
            render();
        });
        openModalButton === null || openModalButton === void 0 ? void 0 : openModalButton.addEventListener("click", openModal);
        closeModalButton === null || closeModalButton === void 0 ? void 0 : closeModalButton.addEventListener("click", closeModal);
        cancelModalButton === null || cancelModalButton === void 0 ? void 0 : cancelModalButton.addEventListener("click", closeModal);
        modalBackdrop === null || modalBackdrop === void 0 ? void 0 : modalBackdrop.addEventListener("click", closeModal);
        weightInput === null || weightInput === void 0 ? void 0 : weightInput.addEventListener("input", updateWeightDisplay);
        addForm === null || addForm === void 0 ? void 0 : addForm.addEventListener("submit", (event) => {
            var _a;
            event.preventDefault();
            if (!nameInput || !weightInput) {
                return;
            }
            const name = nameInput.value.trim();
            const weight = parseInt(weightInput.value, 10);
            const typeInput = addForm.querySelector('input[name="type"]:checked');
            const type = ((_a = typeInput === null || typeInput === void 0 ? void 0 : typeInput.value) !== null && _a !== void 0 ? _a : "pro");
            if (!name || Number.isNaN(weight) || weight < 1) {
                return;
            }
            state.addItem({ name, weight, type });
            closeModal();
            render();
        });
    };
    render();
    addListeners();
});
